export default __webpack_public_path__ + "static/media/Screenshot_1619919050.5c44ee31.png";